<template>
  <el-carousel
    class="gallery-carousel"
    type="card"
    height="275px"
    :autoplay="autoplay"
    indicator-position="none"
    arrow="always"
    @change="setActiveItem"
  >
    <el-carousel-item v-for="(photo, index) in photos" :key="index">
      <div class="gallery-carousel__card">
        <img :src="photo.url" :alt="photo.fileName" />
        <div
          :class="[
            carouselIndex == index
              ? 'gallery-carousel__card_text'
              : 'gallery-carousel__card_curtain'
          ]"
        >
          <span v-if="carouselIndex == index">{{ photo.description }}</span>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "GalleryCarousel",
  props: {
    photos: Array,
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      carouselIndex: 0
    };
  },
  computed: {},
  methods: {
    setActiveItem(val) {
      this.carouselIndex = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery-carousel {
  text-align: center;

  .gallery-carousel__card {
    position: relative;
    display: inline-block;
    overflow: hidden;
    box-sizing: border-box;
    width: 400px;
    height: 272px;

    img {
      width: 400px;
      padding: 0;
      margin: 0;
    }

    .gallery-carousel__card_text {
      display: block;
      position: absolute;
      box-sizing: border-box;
      left: 0;
      bottom: -100%;
      width: 100%;
      height: 90px;
      color: #fff;
      font-size: 30px;
      font-weight: 600;
      font-style: italic;
      background: rgba(192, 196, 204, 0.6);
      -webkit-transition: all 0.7s cubic-bezier(0, 0, 1, 1) 0s;
      -o-transition: all 0.7s cubic-bezier(0, 0, 1, 1) 0s;
      -ms-transition: all 0.7s cubic-bezier(0, 0, 1, 1) 0s;
      -moz-transition: all 0.7s cubic-bezier(0, 0, 1, 1) 0s;
      transition: all 0.7s cubic-bezier(0, 0, 1, 1) 0s;

      span {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        box-sizing: border-box;
        height: 100%;
        color: #fff;
      }
    }

    .gallery-carousel__card_curtain {
      display: block;
      position: absolute;
      box-sizing: border-box;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(192, 196, 204, 0.6);
    }
  }

  .gallery-carousel__card:hover .gallery-carousel__card_text {
    bottom: 0px;
  }
}
</style>
